module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAAAXNSR0IArs4c6QAAAO1JREFUSEvt1TFOAlEUheGPBCUkFrIKGzrjGtyAlcTYWFjQ0dLYSGJI3AO1O3ADJja27MHYqxh4l0wsyAADZAgkvOpl3p059/w5b27FllZlSzp2Vigaa2KAP7QwLEJlVUfHuMVzJnSF1zKEarjHI0Y4CBWhPK3ZT3R1XKCR4/MIl7jJUveEj5y6MT7xjt84n413NT17QCfDVJhpTuFPSmYXfYxnheKe9FI37RTh2G+yFgrFh09wjtMN0MWrX3ibh26Zg/1M3SJXB0f/dNYZE3eIixrzqLS/dzR2lobfC75xXdbgWxb/ueerott9oQnqvT8ZDPPqWAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/add-group-black.png
// module id = 0JUz
// module chunks = 1